import React, {useContext} from 'react';
import {Modal, Button} from 'antd';
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {deleteTruck, getHeavyMachinery, getWorkers, removeHeavyMachine, removeWorker} from "../api";
import {Request} from "../utils";
import {Store} from "../state_store/provider";
import {HEAVY_MACHINE, WORKER} from "../state_store/actionType";



export default function HeavyDelete(props) {
    const {open, onClose, onOK, data} = props
    const {dispatch} = useContext(Store)
    const onDelete = ()=>{
        const {id} = data

        Request(dispatch, removeHeavyMachine(id), onOK).then(error=>{
            if(!error){
                getHeavyMachinery().then(res=>{
                    if(res.result === 0){
                        dispatch({type:HEAVY_MACHINE, payload:res.heavyMachineryList})
                    }
                })
            }
        })

    }

    return (

        <Modal visible={open}
               footer={null}
               closable={false}
               width={400}
        >
            <div className={"dialog"}>


                <div className={"delete-dialog-body column center"}>
                    <div className={"icon"}>
                        <ExclamationCircleOutlined/>
                    </div>
                    <div className={"title"}>人・資・機材削除</div>
                    <div className={"subtitle"}>
                        この重機を削除しますか？
                    </div>

                </div>
                <div className={"delete-dialog-footer row center"}>
                    <Button type="primary" style={{backgroundColor:"#606060"}}
                            onClick={onClose}
                    >いいえ</Button>
                    <Button
                        onClick={onDelete}
                        type="primary" style={{backgroundColor:"#377EF3"}}>はい</Button>
                </div>
            </div>
        </Modal>
    );
};
